module.exports = __webpack_public_path__ + "fonts/Roboto-Light.69f8a061.woff2";